import { createSlice } from '@reduxjs/toolkit';

import { loadRegulationsItem, loadRegulationsList } from './actions';
import { RegulationsState } from './interfaces';

export const regulationsSlice = createSlice({
  name: 'regulations',
  initialState: {
    list: [],
    item: null,
    limit: 20,
    total: 0,
    offset: 0,
  } as RegulationsState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(
      loadRegulationsList.fulfilled,
      (state, { payload: { data, total } }) => {
        state.list = data;
        state.total = total;
      }
    );
    builder.addCase(loadRegulationsItem.fulfilled, (state, { payload }) => {
      state.item = payload;
    });
  },
});
